module.exports = __webpack_public_path__ + "img/Group6.87f1a6ac.png";